import React, { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import logo from '../static/Crunch Time Jobs.png';
import background from '../static/login_background.jpg';
import '../static/user.css';
import { url } from "../Components/url";
import { Spinner } from "react-bootstrap";

function ResetPassword() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') || '';
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [validToken, setValidToken] = useState(!!token);

    useEffect(() => {
        if (!token) setValidToken(false);
    }, [token]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        if (password !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }
        if (password.length < 8) {
            setError('Password must be at least 8 characters.');
            return;
        }
        try {
            setIsLoading(true);
            const response = await fetch(`${url}/reset-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ token, password }),
            });
            const data = await response.json().catch(() => ({}));
            if (response.ok) {
                setMessage('Password reset successful. You can now sign in.');
                setPassword('');
                setConfirmPassword('');
            } else {
                setError(data.message || 'Invalid or expired reset link.');
            }
        } catch (err) {
            setError('An error occurred. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    if (!validToken) {
        return (
            <div className="login-container">
                <div className="login-background"><img src={background} alt="Background" /></div>
                <div className="login-content">
                    <div className="login-card">
                        <div className="login-header">
                            <img src={logo} alt="Logo" className="login-logo" />
                            <h1 className="login-title">Invalid link</h1>
                            <p className="login-subtitle">This reset link is missing or invalid.</p>
                        </div>
                        <div className="login-body">
                            <Link to="/forgot-password" className="btn btn-primary" style={{ width: '100%' }}>Request new link</Link>
                            <p className="mt-3 text-center"><Link to="/" className="login-link">Back to sign in</Link></p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="login-container">
            <div className="login-background">
                <img src={background} alt="Background" />
            </div>
            <div className="login-content">
                <div className="login-card">
                    <div className="login-header">
                        <img src={logo} alt="Logo" className="login-logo" />
                        <h1 className="login-title">Set new password</h1>
                        <p className="login-subtitle">Choose a secure password (at least 8 characters)</p>
                    </div>
                    <form onSubmit={handleSubmit} className="login-body">
                        <div className="login-form-group">
                            <label htmlFor="password" className="login-form-label">New password</label>
                            <input
                                type="password"
                                id="password"
                                className="login-form-control"
                                placeholder="Enter new password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                minLength={8}
                            />
                        </div>
                        <div className="login-form-group">
                            <label htmlFor="confirmPassword" className="login-form-label">Confirm password</label>
                            <input
                                type="password"
                                id="confirmPassword"
                                className="login-form-control"
                                placeholder="Confirm new password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                                minLength={8}
                            />
                        </div>
                        {message && (
                            <div className="alert alert-success mt-2" style={{ fontSize: '0.875rem' }}>{message}</div>
                        )}
                        {error && (
                            <div className="login-error d-flex align-items-center mt-2 text-danger" style={{ fontSize: '0.875rem' }}>{error}</div>
                        )}
                        <button type="submit" className="btn btn-primary mt-3" style={{ width: '100%', padding: '0.75rem' }}>
                            {isLoading ? <Spinner animation="border" size="sm" /> : 'Reset password'}
                        </button>
                        <p className="mt-3 text-center">
                            <Link to="/" className="login-link">Back to sign in</Link>
                        </p>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ResetPassword;
